import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoadingComponent = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Make the container full height
        width: '100vw',  // Full width of the viewport
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingComponent;
